<div class="dialog-container">

  <div class="dialog-header">
    <div class="dialog-header-icon">
      <mat-icon>print</mat-icon>
    </div>
    <div class="dialog-header-text">
      <h2 class="dialog-title">{{ 'permit.manage.print.dialog_title' | translate }}</h2>
      <p class="dialog-subtitle">{{ 'permit.manage.print.dialog_hint' | translate }}</p>
    </div>
    <button type="button" class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">

    <!-- Citizen group -->
    <div class="section-group">
      <div class="group-label">{{ 'permit.manage.print.group.citizen' | translate }}</div>
      <div class="section-row"
           *ngFor="let section of citizenSections"
           [class.deselected]="!section.selected"
           [class.row-disabled]="section.disabled"
           (click)="toggleByKey(section.key)">
        <mat-checkbox
          [checked]="section.selected"
          [disabled]="section.disabled"
          (change)="toggleByKey(section.key)"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <span class="section-label">{{ section.label }}</span>
        <span class="empty-badge" *ngIf="section.disabled">{{ 'permit.manage.print.empty' | translate }}</span>
      </div>
    </div>

    <!-- Internal group -->
    <div class="section-group">
      <div class="group-label">{{ 'permit.manage.print.group.internal' | translate }}</div>
      <div class="section-row"
           *ngFor="let section of internalSections"
           [class.deselected]="!section.selected"
           [class.row-disabled]="section.disabled"
           (click)="toggleByKey(section.key)">
        <mat-checkbox
          [checked]="section.selected"
          [disabled]="section.disabled"
          (change)="toggleByKey(section.key)"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <span class="section-label">{{ section.label }}</span>
        <span class="empty-badge" *ngIf="section.disabled">{{ 'permit.manage.print.empty' | translate }}</span>
      </div>
    </div>

  </div>

  <div class="dialog-footer">
    <button type="button" class="btn-cancel" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn-print" (click)="print()" [disabled]="selectedCount === 0">
      <mat-icon>print</mat-icon>
      {{ 'common.print' | translate }}
    </button>
  </div>

</div>
